import { fullLanguageToLocale, getLocale, localeInitialised, locales, setLocale } from '@/ui/i18n/i18n';

export const useSetLocale = (locale: locales | undefined) => {
  if (locale) {
    setLocale(locale);
  }
};

export const useSetBrowserLocale = (safe = true) => {
  let locale: locales;
  if (safe) {
    locale = localeInitialised.value ? getLocale() : fullLanguageToLocale(window.navigator.language);
  } else {
    locale = fullLanguageToLocale(window.navigator.language);
  }

  if (locale) {
    // since we don't know the logged in user's locale, we use the browser's locale
    setLocale(locale);
  }
};
